import { useCallback } from 'react'

import Routes from '@tabeeb/routes'
import { SideNavbar } from '@collaborate-health/uikit'
import { useSelector } from '@tabeeb/store'
import { getLogoUrl } from '@tabeeb/modules/appConfigState/selectors'

import {
  CorporationsTab,
  CustomIFrameTab,
  FormsTab,
  GeosearchTab,
  SessionsTab,
  SettingsTab,
  ReportsTab,
  TenantsTab,
  ThreeDimensionalModelsTab,
  TrackingTab,
  TrainingMaterialsTab,
  BulkImportTab,
  HelpTab,
  LogoutButton,
  CalendarTab,
  SwitchTenantButton,
  AITab,
  CertificatesTab,
  CreditsTab,
} from '../Tabs'

import User from '../User'

export interface NavbarProps {
  hidden?: boolean
  children?: React.ReactNode
}

const SIDEBAR_STATE_KEY = 'sidebar.open'

const Navbar: React.FC<NavbarProps> = ({ hidden, children }) => {
  const logoUrl = useSelector(getLogoUrl)

  const cachedSidebarOpenState = localStorage.getItem(SIDEBAR_STATE_KEY)

  const onExpanded = useCallback(() => {
    localStorage.setItem(SIDEBAR_STATE_KEY, `${true}`)
  }, [])

  const onCollapsed = useCallback(() => {
    localStorage.setItem(SIDEBAR_STATE_KEY, `${false}`)
  }, [])

  return (
    <SideNavbar
      root={Routes.home}
      hidden={hidden}
      initiallyOpen={cachedSidebarOpenState !== 'false'}
      onExpanded={onExpanded}
      onCollapsed={onCollapsed}
      logoUrl={logoUrl}
      user={<User />}
      main={
        <>
          <SessionsTab />
          <FormsTab />
          <ThreeDimensionalModelsTab />
          <GeosearchTab />
          <TrackingTab />
          <ReportsTab />
          <CustomIFrameTab />
          <SettingsTab />
          <AITab />
          <TenantsTab />
          <CorporationsTab />
          <TrainingMaterialsTab />
          <BulkImportTab />
          <CertificatesTab />
        </>
      }
      footer={
        <>
          <CalendarTab />
          <HelpTab />
          <CreditsTab />
          <SwitchTenantButton />
          <LogoutButton />
        </>
      }
    >
      {children}
    </SideNavbar>
  )
}

export default Navbar

